import React from "react";
import { Autocomplete, Popper, createFilterOptions } from "@mui/material";
import { CustomTextField } from "../Textfield";
import { COUNTRY_CODES } from "../../../Utils/mobile";

// Match on country name or dial code, with or without "+"
const filterOptions = createFilterOptions({
  stringify: ({ name, code }) => `${name} +${code} ${code}`,
});

const WidePopper = (props) => (
  <Popper
    {...props}
    placement="bottom-start"
    style={{ ...props.style, width: "fit-content", minWidth: 240 }}
  />
);

export const CountryCodeSelect = ({
  value,
  onChange,
  style,
  label = "Country",
  ...props
}) => (
  <Autocomplete
    disableClearable
    autoHighlight
    options={COUNTRY_CODES}
    value={COUNTRY_CODES.find((c) => c.code === value) ?? null}
    isOptionEqualToValue={(option, selected) => option.code === selected.code}
    getOptionLabel={(option) => `+${option.code}`}
    filterOptions={filterOptions}
    PopperComponent={WidePopper}
    sx={{
      "& .MuiAutocomplete-popupIndicator": {
        color: "#663399",
        backgroundColor: "rgba(102, 51, 153, 0.08)",
        "&:hover": {
          backgroundColor: "rgba(102, 51, 153, 0.16)",
        },
      },
    }}
    onChange={(event, option) =>
      onChange({ target: { name: "countryCode", value: option.code } })
    }
    renderOption={(optionProps, option) => (
      <li {...optionProps} key={option.code}>
        {option.name} (+{option.code})
      </li>
    )}
    renderInput={(params) => (
      <CustomTextField {...params} label={label} {...props} />
    )}
    style={{ width: "40%", minWidth: 110, flexShrink: 0, ...style }}
  />
);
